"use strict";
const EventImpl = require("./Event-impl.js").implementation;

exports.implementation = class PopStateEventImpl extends EventImpl {};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsdom/lib/jsdom/living/events/PopStateEvent-impl.js
// module id = +PYt
// module chunks = 1